// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getEventGroupTrackingResponse } from '@/asset/api/get-event-group-tracking';
import { TrackingHistory } from '@/tracking/components/tracking-history';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  aegKey: string;
  assetKey: string;
}

/**
 * Displays carrier tracking history for an asset event group.
 * Fetches tracking data from the API and renders it using the shared TrackingHistory component.
 */
export function AssetTrackingHistory(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: [
      'asset',
      props.assetKey,
      'event-group',
      props.aegKey,
      'shipping',
    ],
    queryFn: () => getEventGroupTrackingResponse(props.assetKey, props.aegKey),
  }).data;

  return <TrackingHistory data={data} />;
}
